export const formatMoney = (number, isPreserveDecimals = false) => {
  if (!number) {
    return number;
  }
  let formattedNumber;
  if (isPreserveDecimals) {
    const hasDecimals = number % 1 !== 0;
    formattedNumber = hasDecimals ? parseFloat(number).toFixed(2) : parseInt(number, 10).toString();
  } else {
    formattedNumber = parseInt(number, 10).toString();
  }

  return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
